import { render, staticRenderFns } from "./AddEventStep.vue?vue&type=template&id=187d80ac&scoped=true&"
import script from "./AddEventStep.vue?vue&type=script&lang=js&"
export * from "./AddEventStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187d80ac",
  null
  
)

export default component.exports